"use strict";
function e(_) {
  return !!(_ && _.__CANCEL__);
}
export {
  e as default
};
//# sourceMappingURL=index.es152.js.map
